/* Loads the OWB pattern engine (gun outlines + generator) from Shopify Files: Content > Files > owb-pattern-engine.js. Re-upload that file to update the engine. */
(function () {
  var s = document.createElement('script');
  s.src = 'https://cdn.shopify.com/s/files/1/0705/0860/9765/files/owb-pattern-engine.js?v=1792782839';
  s.async = true;
  s.onerror = function () { var e = document.getElementById('owbp-status'); if (e) e.textContent = 'The pattern engine could not load. Please refresh the page or contact us.'; };
  document.head.appendChild(s);
})();
